const loadLocationNav = () => {
    const locationBanner = document.querySelector('.location-banner')
    const locationNav = document.querySelector('.location-nav')

    if (locationBanner && locationNav) {
        document.addEventListener('scroll', () => {
            const locationBannerBottom = locationBanner.getBoundingClientRect().bottom

            if (locationBannerBottom <= 60) {
                locationNav.classList.add('fixed')
            } else {
                locationNav.classList.remove('fixed')
            }
        })
    }
}

export default loadLocationNav



// WEBPACK FOOTER //
// ./js/locationNav.js